import { useEffect, useState, useCallback } from "react";
import { getMemberSession, memberLogout } from "@/lib/memberSession";

/**
 * Returns the current member-session claims (or null) and helpers.
 * Reads once on mount — token has already been parsed into sessionStorage by
 * `initMemberSessionFromUrl()` at App boot.
 */
export default function useMemberSession() {
    const [claims, setClaims] = useState(() => getMemberSession());

    useEffect(() => {
        // In case the App-level init ran after the first render, re-read.
        const c = getMemberSession();
        if (c !== claims) setClaims(c);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const logout = useCallback(() => {
        memberLogout();
    }, []);

    return {
        isMember: claims !== null,
        claims,
        logout,
    };
}
